'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripWeetjesV1.$inject = ['ApiService'];


var _ = {
    each: _each3.default
};

var _module = angular.module('cb.strips.cbWeetjesV1', []);

_module.directive('cbStripWeetjesV1', cbStripWeetjesV1);

exports.default = _module;


function cbStripWeetjesV1(ApiService) {
    return {
        restrict: 'A',
        link: cbStripWeetjesV1Link
    };

    function cbStripWeetjesV1Link(scope, element, attr) {

        /* Get each content-block (one 'weetje') and register its controller with the defined getters and setters
         * Usage:
         *  cb('weetjes', 'set', [index], {
         *     title: ...,
         *     link: ...,
         *     linkText: ...,
         *     theme: ...
         * });
         *
         * To use the getter in Relay or other code blocks
         * var w;
         * cb('weetjes', 'get', [index], (weetje) => { w = weetje; });
         */
        _.each(element.find('.content-block'), function (contentBlockElement) {
            contentBlockElement = angular.element(contentBlockElement);
            var _gettersAndSetters = addGettersAndSetters(contentBlockElement);
            var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

            ApiService.attach({
                'weetjes': gettersAndSetters
            });
        });
    }

    // Define getters and setters, used in cb-functions
    function addGettersAndSetters(element) {
        var weetje = {};

        Object.defineProperty(weetje, 'image', {
            get: function get() {
                return element.find('.content-block__image-img').attr('src');
            },
            set: function set(newValue) {
                element.find('.content-block__image-img').attr('src', newValue);
            }
        });

        Object.defineProperty(weetje, 'imageAlt', {
            get: function get() {
                return element.find('.content-block__image-img').attr('alt');
            },
            set: function set(newValue) {
                element.find('.content-block__image-img').attr('alt', newValue);
            }
        });

        Object.defineProperty(weetje, 'title', {
            get: function get() {
                return element.find('.heading-strip-subtitle').html();
            },
            set: function set(newValue) {
                element.find('.heading-strip-subtitle').html(newValue);
            }
        });

        Object.defineProperty(weetje, 'text', {
            get: function get() {
                return element.find('.text').html();
            },
            set: function set(newValue) {
                element.find('.text').html(newValue);
            }
        });

        Object.defineProperty(weetje, 'link', {
            get: function get() {
                return element.find('.link').attr('href');
            },
            set: function set(newValue) {
                element.find('.link').attr('href', newValue);
            }
        });

        Object.defineProperty(weetje, 'theme', {
            get: function get() {
                return (0, _from2.default)(element[0].classList).find(function (className) {
                    return className.indexOf('t-content-block--') === 0;
                }).replace(/^t-content-block--/, '');
            },
            set: function set(newValue) {
                var colors = ['groen', 'mais', 'cappuccino', 'fuchsia', 'blauw'];
                if (!colors.includes(newValue)) {
                    throw new Error('Invalid color \'' + newValue + '\'; valid colors are: ' + colors);
                }

                // Remove all classes starting with t-content-block--
                (0, _from2.default)(element[0].classList).filter(function (className) {
                    return className.indexOf('t-content-block--') === 0;
                }).forEach(function (className) {
                    element.removeClass(className);
                });

                element.addClass('t-content-block--' + newValue);
            }
        });

        return weetje;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/weetjes-v1/weetjes.directive.js
// module id = 964
// module chunks = 1